import { push } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import useSchema from "hooks/useSchema";
import Button from "pages/_components/Button";
import ProductSelector from "pages/_components/fields/formik/FormikProductSelector";
import TextField from "pages/_components/fields/TextField";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import * as i18n from "util/i18n";
import * as Yup from "yup";
import * as config from "util/config";
import AmountEchecks from "../components/AmountEchecks";
import { useEcheckAccountSelector } from "../hooks/useEcheckAccouts";

const ARS = "ARS";
const CHECKING_ACCOUNT = "CC";
const FORM_ID = "echeq.request";
const MAX_AMOUNT_ECHEQS = 1000;

const EcheckRequestPage = () => {
    const dispatch = useDispatch();
    const { accountOptions, fetching } = useEcheckAccountSelector(ARS, CHECKING_ACCOUNT);
    const { requestEcheckAmountData } = useSelector((state) => state.echecks);
    // const { echeckAmountData } = useSelector((state) => state.echecks);
    const { stringRequired, numberRequired } = useSchema();
    const placeholder = i18n.get("global.select");
    const [selectedAccountId, setSelectedAccountId] = useState("");

    const initialValues = {
        idAccount: requestEcheckAmountData.idAccount ?? "",
        amount: config.get("echeq.initial.amount", 50),
    };

    const validateEcheqAmount = (value) =>
        // const availableEcheqs = echeckAmountData.maxEcheqAmount - echeckAmountData.usedEcheqAmount;
        value <= MAX_AMOUNT_ECHEQS;
    const requestEcheckSchema = Yup.object().shape({
        idAccount: stringRequired,
        amount: numberRequired.test("max", i18n.get(`maxEcheqAmount.error`), validateEcheqAmount),
    });

    const handleSubmit = (values) => {
        dispatch(echeckActions.setRequestEcheckAmountData(values));
        dispatch(push("/echecks/requestAmount/confirm"));
    };

    useEffect(() => {
        if (requestEcheckAmountData.idAccount) {
            dispatch(echeckActions.requestAmountEchecks(requestEcheckAmountData.idAccount));
        }
    }, [requestEcheckAmountData.idAccount]);

    return (
        <>
            <Notification scopeToShow="echecksRequest" />
            <ResponsiveHeader id="echecks.request.title" />
            <MainContainer showLoader={fetching}>
                <AmountEchecks selectedAccountId={selectedAccountId} />
                <Formik initialValues={initialValues} validationSchema={requestEcheckSchema}>
                    {({ values }) => {
                        const canSubmit = !values.idAccount || !values.amount;
                        const disabled = true;

                        return (
                            <>
                                <Form>
                                    <Row>
                                        <Col xs={12}>
                                            <Field
                                                component={ProductSelector}
                                                label={`${i18n.get(`${FORM_ID}.account.label`)}*`}
                                                name="idAccount"
                                                placeholder={placeholder}
                                                data={{ emptyOptionLabel: "", options: accountOptions }}
                                                onChange={setSelectedAccountId}
                                            />
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <Field
                                                component={TextField}
                                                labelnoI18n={`${i18n.get(`${FORM_ID}.amount.label`)}*`}
                                                name="amount"
                                                type="number"
                                                min={1}
                                                max={config.getInteger("echeck.new.limit", 1000)}
                                                disabled={disabled}
                                                hidePlaceholder
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={canSubmit}
                                            onClick={() => handleSubmit(values)}
                                        />
                                    </Col>
                                </Row>
                            </>
                        );
                    }}
                </Formik>
            </MainContainer>
        </>
    );
};

export default EcheckRequestPage;
